import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Typography, Box } from '@mui/material';
import Close from '@mui/icons-material/Close';
import { INDICATOR_INFO } from './indicatorInfo';

/** Static explainer popup for one indicator card; `name` null = closed. */
const IndicatorInfoDialog: React.FC<{ name: string | null; onClose: () => void }> = ({ name, onClose }) => {
  const info = name ? INDICATOR_INFO[name] : undefined;
  return (
    <Dialog open={!!info} onClose={onClose} maxWidth="sm" fullWidth
            aria-labelledby="indicator-info-title">
      <DialogTitle id="indicator-info-title" sx={{ pr: 6 }}>
        {name}
        <IconButton onClick={onClose} aria-label="Close" sx={{ position: 'absolute', right: 8, top: 8 }}>
          <Close />
        </IconButton>
      </DialogTitle>
      {info && (
        <DialogContent dividers>
          <Typography variant="subtitle2">What it is</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{info.whatItIs}</Typography>
          <Typography variant="subtitle2">Role in strategy 1</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{info.role}</Typography>
          <Typography variant="subtitle2">What moves its score</Typography>
          <Box component="ul" sx={{ mt: 0.5, mb: 0, pl: 2.5 }}>
            {info.scoreMoves.map((line, i) => (
              <Typography key={i} component="li" variant="body2" color="text.secondary">{line}</Typography>
            ))}
          </Box>
        </DialogContent>
      )}
    </Dialog>
  );
};

export default IndicatorInfoDialog;
